export const heroCopy = {
  brand: 'Northlight',
  brandSub: 'Windows & Skylights',
  nav: [
    { label: 'Windows', href: '#windows' },
    { label: 'Comfort', href: '#comfort' },
    { label: 'Process', href: '#process' },
    { label: 'Projects', href: '#projects' },
  ],
  phone: '(503) 555-0148',
  compactCta: 'Estimate',
  scrollHint: 'Scroll to step outside',
  eyebrow: 'Window replacement & installation',
  headline: 'A Better View Begins at Home.',
  copy: 'Thoughtfully installed windows that bring more light, comfort, and possibility into everyday living.',
  cta: 'Get a Free Estimate',
  ctaHref: '#estimate',
};

export const heroFloat = {
  left: { eyebrow: 'Windows that bring you closer', l1: 'A different', l2: 'point of view.' },
  right: { eyebrow: '01 / The experience', l1: 'Closer to light.', l2: 'Closer to nature.' },
};

// Optimised production assets (Phase 06). forest = same continuous panorama, 1024x2048 WebP q80.
export const heroAssets = {
  atticForeground:
    'https://storage.helloreaddy.io/project_files/22695a42-693b-4158-a319-51aca0c9f872/0f2e56ae-f210-437f-a7de-ca2d164175d4_compressed_02_attic_foreground_TRANSPARENT_WINDOW.webp',
  forest:
    'https://public.readdy.ai/ai/img_res/sandbox/52cdcd16a5556f6302fcb5f05fda2c37/d504a9d8-43f0-415a-838b-e8ea414aedab_nl-forest.webp',
};